import Image from 'next/image';
import type { CertificadoAcessosArbitral } from '../../../types/certificadoAcessosTypes';

interface SecaoEncerramentoProps {
  certificado: Pick<CertificadoAcessosArbitral, 'instituicao' | 'codigoAutenticacao'>;
}

export function SecaoEncerramento({ certificado }: SecaoEncerramentoProps) {
  const { instituicao } = certificado;

  return (
    <>
      <div className="bg-brand-600/10 flex items-end justify-between px-[43px] py-[26px]">
        <div className="flex flex-col gap-[14px]">
          <Image
            src={instituicao.logoUrl}
            alt={instituicao.orgao}
            width={93}
            height={22}
            className="h-[22px] w-fit object-contain"
          />
          <span className="text-brand-600 text-[13.5px]">
            {instituicao.contatoEmail} | {instituicao.contatoSite}
          </span>
        </div>
        <div className="text-right">
          <span className="text-[11px] text-neutral-900/50">Assinado digitalmente por:</span>
          <Image
            src={instituicao.assinaturaImagemUrl}
            alt={`Assinatura de ${instituicao.orgao}`}
            width={160}
            height={56}
            className="ml-auto h-[52px] w-auto object-contain"
          />
          <div className="mt-[2px] border-t border-solid border-neutral-900 pt-[6px] text-[12.5px] text-neutral-700">
            {instituicao.assinaturaCargo}
            <br />
            <strong className="text-brand-600">{instituicao.orgao}</strong>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between border-t border-solid border-neutral-200 px-[43px] py-[13px]">
        <span className="text-[10.5px] text-neutral-400">
          Documento gerado automaticamente pela Plataforma Arbitralis.
        </span>
        {certificado.codigoAutenticacao && (
          <span className="text-[9px] tracking-[1px] text-neutral-400 uppercase">
            Cód. de Autenticação&nbsp;·&nbsp;
            <span className="font-semibold text-neutral-500">{certificado.codigoAutenticacao}</span>
          </span>
        )}
      </div>
    </>
  );
}
